import React from "react";
import { useLanguage } from "../context/LanguageContext";

export default function LanguageToggle({ compact = false }) {
  const { lang, setLang } = useLanguage();
  const btn = (code, label) => {
    const active = lang === code;
    return (
      <button
        key={code}
        onClick={() => setLang(code)}
        aria-pressed={active}
        aria-label={code === "de" ? "Deutsch" : "English"}
        className={`px-2 py-1 rounded-md text-[12px] font-medium tracking-wider uppercase transition-colors duration-200 ${
          active
            ? "text-[#0B1F3A] bg-slate-100"
            : "text-slate-500 hover:text-[#0B1F3A]"
        }`}
      >
        {label}
      </button>
    );
  };
  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex items-center gap-0.5 rounded-md border border-slate-200 bg-white/70 backdrop-blur-sm p-0.5 ${
        compact ? "" : ""
      }`}
    >
      {btn("de", "DE")}
      <span className="text-slate-300 text-[10px]" aria-hidden="true">|</span>
      {btn("en", "EN")}
    </div>
  );
}
